export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://vinosk.fr/api',
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/authenticate',
      REGISTER: '/auth/register',
      LOGOUT: '/auth/logout',
      ME: '/auth/me'
    },
    BOTTLES: {
      LIST: '/bouteille/list',
      CREATE: '/bouteille/create',
      CREATE_WITH_IMAGE: '/bouteille/create-with-image',
      GET: (reference: string) => `/bouteille/find/${reference}`,
      FIND: '/bouteille/find',
      UPDATE: '/bouteille/update',
      DELETE: '/bouteille/delete',
      ARCHIVE: '/bouteille/archive',
      ARCHIVED: '/bouteille/archives',
      ADD_PICTURE: (reference: string) => `/bouteille/add/picture/${reference}`
    }
  }
};

export const AUTH_TOKEN_KEY = 'vinosk_auth_token';
export const USER_KEY = 'vinosk_user';

export const BOTTLE_TYPES_LABELS = {
  RED: 'Vin Rouge',
  WHITE: 'Vin Blanc',
  ROSE: 'Vin Rosé',
  CHAMPAGNE: 'Champagne',
  SPIRITS: 'Spiritueux'
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  BOTTLES: '/bottles',
  BOTTLE_DETAIL: '/bottles/:id',
  BOTTLE_ADD: '/bottles/add',
  BOTTLE_EDIT: '/bottles/:id/edit',
  ARCHIVED: '/archived',
  SEARCH: '/search',
  PROFILE: '/profile',
  SETTINGS: '/settings'
};